import { render } from "./ClicksImpressionsByKeywords.vue?vue&type=template&id=93822614&ts=true"
import script from "./ClicksImpressionsByKeywords.vue?vue&type=script&lang=ts"
export * from "./ClicksImpressionsByKeywords.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__